import React, { useState, useEffect } from 'react';
import {
    withDebugMode, withStylesLoaded, compose,
} from '@concur/core-ui-shell';
import IdleTimer from './_IdleTimer';
import withNuiIntl from '../utils/withNuiIntl';
import withStylesPlaceholder from '../utils/withStylesPlaceholder';
import { getCacheKey } from '../utils/sessionStorageUtils';

const DEBUG_COOKIE_NAME = 'idle_timer_debug';
const DEBUG_COOKIE_MAX_AGE = 7200; // 2 hours

// this wrapper component is necessary to wrap the component
// in a ThemeProvider (handled in withStylesLoaded)
const AppIdleTimer = (props) => {
    const {
        brandingLogo,
        configOptions,
        oshCacheIdentifier,
        ...otherProps
    } = props;

    const [cdsData, setCdsData] = useState();
    const cacheKey = getCacheKey(oshCacheIdentifier);

    useEffect(() => {
        const existingSessionData = window.sessionStorage
            && JSON.parse(window.sessionStorage.getItem(cacheKey));
        if (existingSessionData) {
            setCdsData(existingSessionData);
        }
    }, []);

    return (
        <IdleTimer
            {...otherProps}
            brandingLogo={cdsData?.brandingLogo || brandingLogo}
            configOptions={configOptions}
            showError={() => false}
            oshCacheIdentifier={oshCacheIdentifier}
        />
    );
};

AppIdleTimer.displayName = 'AppIdleTimer';

AppIdleTimer.propTypes = {
    ...IdleTimer.propTypes,
};

export default compose(
    withDebugMode(DEBUG_COOKIE_NAME, DEBUG_COOKIE_MAX_AGE),
    withStylesPlaceholder,
    withStylesLoaded,
    withNuiIntl,
)(AppIdleTimer);
